import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { ArrowRight } from "lucide-react";

export default function MyResearch() {
  const { authAxios } = useAuth();
  const { tr } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await authAxios.get("/research");
        setItems(r.data);
      } catch (e) {}
      setLoading(false);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-10 py-10">
        <div className="pfi-overline">PERSONA 5.0</div>
        <div className="mt-3 flex items-start justify-between gap-4 flex-wrap">
          <div>
            <h1 className="font-serif text-3xl sm:text-4xl" data-testid="my-research-title">{tr("p5_research_title")}</h1>
            <p className="mt-2 text-[#a9a9b8] text-sm">{tr("p5_research_sub")}</p>
          </div>
          <Link to="/perfumery-tech-app" data-testid="new-research-btn"
            className="pfi-btn-gold rounded-full px-5 py-2.5 text-sm inline-flex items-center gap-2 shrink-0">
            {tr("p5_new_research")} <ArrowRight size={14} />
          </Link>
        </div>

        <div className="mt-8">
          {loading ? <div className="text-[#a9a9b8] text-sm">{tr("loading")}</div> :
            items.length === 0 ? (
              <div className="pfi-card p-10 text-center text-[#a9a9b8]" data-testid="my-research-empty">
                {tr("p5_research_empty")}
                <div className="mt-4">
                  <Link to="/perfumery-tech-app" className="pfi-btn-gold rounded-full px-5 py-2.5 text-sm inline-flex items-center gap-2">
                    {tr("p5_pt_title")} <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            ) : (
              <div className="space-y-3">
                {items.map((r) => (
                  <div key={r.public_id} className="pfi-card p-5 flex items-center justify-between gap-4" data-testid={`research-item-${r.public_id}`}>
                    <div className="min-w-0">
                      <div className="pfi-overline">{new Date(r.created_at).toLocaleString()} · {r.access_state}</div>
                      <div className="mt-1 font-serif text-lg truncate">{r.name}</div>
                      <div className="mt-1 text-xs text-[#e6c687] font-mono truncate">{r.public_id}</div>
                    </div>
                    <Link to={`/research/${r.public_id}`} data-testid={`open-research-${r.public_id}`}
                      className="pfi-btn-outline rounded-full px-4 py-2 text-xs inline-flex items-center gap-2">
                      {tr("p5_research_view")} <ArrowRight size={12} />
                    </Link>
                  </div>
                ))}
              </div>
            )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
